import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const WhoBackground = styled.div`
  width: 100%;
  background-color: #8ad6d7;
`;

export const WhoContainer = styled.div`
  padding: 50px 20px;
  max-width: 1340px;
  margin: 0 auto;

  @media ${sizes.tabletLandscape} {
    padding: 0px 40px;
    padding-top: 180px;
    padding-bottom: 100px;
  }
`;

export const Title = styled.h1`
  color: ${th('colors.black')};
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  font-size: 24px;

  @media ${sizes.tabletLandscape} {
    font-size: 32px;
    line-height: 44px;
  }
`;

export const Description = styled.p`
  width: 100%;
  max-width: 900px;
  margin-bottom: 60px;
  margin-top: 10px;
  color: ${th('colors.black')};
`;

export const ItemsContainer = styled.div`
  display: grid;
  grid-template-columns: 220px;
  padding-left: 10px;
  grid-column-gap: 80px;
  grid-row-gap: 40px;
  justify-content: center;

  @media ${sizes.tabletPortrait} {
    grid-template-columns: 220px 220px;
  }

  @media ${sizes.tabletLandscape} {
    grid-column-gap: 120px;
    grid-row-gap: 60px;
  }

  @media ${sizes.desktop} {
    display: flex;
    justify-content: space-between;
    grid-gap: 0;
  }
`;

export const Item = styled.div`
  text-align: center;

  > h2 {
    margin: 0;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    width: 220px;
    color: ${th('colors.black')};
    margin-top: 30px;

    @media ${sizes.tabletLandscape} {
      font-size: 20px;
    }
  }
`;

export const ImageContainer = styled.div`
  width: 184px;
  height: 184px;
  border-radius: 100%;

  margin: 0px auto;

  > img {
    width: 100%;
    height: 100%;
  }
`;
